import React, { useState } from 'react';

import './index.scss';

import moment from 'moment';
import CirclePoint from '../CirclePoint/CirclePoint.jsx';

import SettingsCard from '../SettingsCard/SettingsCard';

const IntelligenceCard = ({
  objects,
  label,
  user,
  blt,
  qtd,
  editItem,
  updatedDate,
  deleteItem,
}) => {
  return (
    <div
      className={
        blt === 'entidades'
          ? 'intelligence-card-entidades'
          : 'intelligence-card'
      }
    >
      <SettingsCard
        blt={blt}
        label={label}
        user={user}
        objects={objects}
        deleteItem={() => deleteItem(label)}
        editItem={() => editItem(label)}
      />
      <div className="container-point">
        {blt === 'entidades' ? '' : <span />}

        <div
          className={blt === 'entidades' ? 'textCard-entidades' : 'textCard'}
        >
          <p className="titleCard">{label}</p>
          {blt === 'entidades' ? (
            <p className="subtitle-entidades">Valores</p>
          ) : (
            ''
          )}

          <p>{blt === 'entidades' ? '' : `${qtd} Exemplos`}</p>

          {blt === 'entidades' ? (
            <div className="valores-entidades">
              {objects.map((obj, index) => (
                <span key={`card-entidade-${index}`}>{obj.name}</span>
              ))}
            </div>
          ) : (
            ''
          )}

          {blt === 'entidades' ? (
            ''
          ) : (
            <div style={{ marginTop: 6 }}>
              <CirclePoint item={qtd} />
            </div>
          )}
        </div>

        <div className="container-Data">
          <p>{moment(updatedDate).format('DD/MM/YYYY HH:mm')}</p>
        </div>
      </div>
    </div>
  );
};

export default IntelligenceCard;
